import { render, staticRenderFns } from "./LDBsTable.vue?vue&type=template&id=a79746d6"
import script from "./LDBsTable.vue?vue&type=script&lang=js"
export * from "./LDBsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports